/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bookingsofchildren2Inputs */



/**

* @param {_Field_Bookingsofchildren2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_bookingsofchildren2 = /** @type {((inputs?: _Field_Bookingsofchildren2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bookingsofchildren2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Buchungen der Kinder")
});
export { _field_bookingsofchildren2 as "_field_bookingsOfChildren" }